import cn from 'classnames';
import { memo } from 'react';

import { isExternalLink } from '../../utils/isExternalLink';
import RightArrowBold from '../SVGIcons/RightArrowBold';
import classes from './arrow-link.module.scss';

interface IArrowLinkProps {
  division: string;
  text: string;
  route: string;
}

function ArrowLink({ division, text, route }: IArrowLinkProps) {
  return (
    <div className={classes.container}>
      <a
        className={cn({
          [classes.link]: true,
          [classes[`link${division}`]]: true,
        })}
        {...(isExternalLink(route)
          ? {
            target: '_blank',
            rel: 'noreferrer',
          }
          : {})}
        href={route}
      >
        {text}
        <RightArrowBold color="#1D1D1D" />
      </a>
    </div>
  );
}

export default memo(ArrowLink);
